export const StyleProps1: React.CSSProperties ={
    lineHeight: "12px"
}


export const StyleProps2: React.CSSProperties = {
    textAlign: "center",
    lineHeight: "15px",
    fontSize: "90%"
}


export const StyleProps3 : React.CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid black",
    lineHeight:"10px;font-size:80%",
    textAlign: "left",
    borderCollapse: "collapse"
}


export const StyleProps4: React.CSSProperties = {
    backgroundColor:"#304ACA",
    borderRadius: "1%",
    border: "3px",
    color: "#d9d9f3"
}


export const StylesProps5: React.CSSProperties = {
    backgroundColor: "#ff5100",
    border: "2px inset #001689",
    color:"white",
    lineHeight: "1"
}


export const StylesProps6: React.CSSProperties = {
    backgroundColor: "#d9d9f3",
    border: "1px solid black",
    lineHeight:"12px",
    fontSize: "90%",
    textAlign: "left"
}


export const StyleProps7: React.CSSProperties = {
    backgroundColor:"#304ACA",
    lineHeight: "0px",
    border:"2px solid black"
    // borderCollapse: "separate"
}


export const StyleProps8: React.CSSProperties = {
    color: "#d9d9f3",
    fontSize: "70%"
}


export const StyleProps9: React.CSSProperties = {
    lineHeight: "0",
    border:"2px solid black"
}

export const StylesProps10: React.CSSProperties = {
    backgroundColor:"#d9d9f3",
    lineHeight:"0"
}

export const StylesProps11 : React.CSSProperties = {
    backgroundColor:"#ff5100",
    textAlign: "left",
    color:"white",
    lineHeight: "0"
}

export const StylesProps12 : React.CSSProperties = {
    backgroundColor:"#ff5100",
    textAlign: "right",
    color:"white",
    lineHeight: "0"
}


export const StyleProps13: React.CSSProperties = {
    fontSize: "60%",
    color: "#d9d9f3"
}

export const StyleProps14: React.CSSProperties = {
    border:"1px solid black",
    borderCollapse:"separate",
    color: "black"
}

export const StyleProps15: React.CSSProperties = {
    border:"1px solid black",
    borderCollapse:"separate",
    lineHeight: "1px"
}


export const StylesProps16: React.CSSProperties ={
    fontSize: "60%",
    lineHeight:"-1",
    width:"fit-content"
}


export const StylesProps17: React.CSSProperties ={
    fontSize: "60%",
    lineHeight:"0"
}

export const StyleProps18: React.CSSProperties = {
    lineHeight: 0,
    border:"2px solid black"
}

export const StyleProps19: React.CSSProperties = {
    backgroundColor:"#ff5100",
    textAlign: "left",
    color:"white",
    lineHeight: "0"
}

export const StyleProps20: React.CSSProperties = {
    backgroundColor:"#d9d9f3",
    lineHeight: "0"
}

export const StyleProps21: React.CSSProperties = {
    lineHeight: 0,
    border:"2px solid black"
}

export const StyleProps22: React.CSSProperties = {
    backgroundColor:"#ff5100",
    textAlign: "left",
    color:"white",
    lineHeight: "0"
}

export const estilosImprimir: React.CSSProperties ={
    pageBreakInside: "avoid", /* Evitar cortar la tabla en medio */
    pageBreakBefore: "always" /* Forzar un salto de página antes de la tabla */
}